/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Pipeline_ActionsInputs */

const cs_pipelines_pipeline_actions = /** @type {(inputs: Pipelines_Pipeline_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akce pipeline`)
};

const en_pipelines_pipeline_actions = /** @type {(inputs: Pipelines_Pipeline_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline actions`)
};

/**
* | output |
* | --- |
* | "Pipeline actions" |
*
* @param {Pipelines_Pipeline_ActionsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_pipeline_actions = /** @type {((inputs?: Pipelines_Pipeline_ActionsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Pipeline_ActionsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_pipeline_actions(inputs)
	return cs_pipelines_pipeline_actions(inputs)
});